import ComprehensionIcon from './icon-comprehension.svg';
import PhonicsIcon from './icon-phonics.svg';
import SightwordsIcon from './icon-sightwords.svg';
import SpellingIcon from './icon-spelling.svg';
import GrammarIcon from './icon-grammar.svg';

const icons = {
  comprehension: ComprehensionIcon,
  phonics: PhonicsIcon,
  sightwords: SightwordsIcon,
  spelling: SpellingIcon,
  grammar: GrammarIcon
};

const defaultIcon = SpellingIcon;

const getIcon = (name) => {
  if (name) {
    const iconName = name.toLowerCase();
    if (icons[iconName])
      return icons[iconName];
  }
  return defaultIcon;
};

export default {
  getIcon,
  ComprehensionIcon,
  PhonicsIcon,
  SightwordsIcon,
  SpellingIcon,
  GrammarIcon
};
